import { render } from "./ReplyComment.vue?vue&type=template&id=4e3005c0&scoped=true"
import script from "./ReplyComment.vue?vue&type=script&lang=js"
export * from "./ReplyComment.vue?vue&type=script&lang=js"

import "./ReplyComment.vue?vue&type=style&index=0&id=4e3005c0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4e3005c0"

export default script